import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { NavPresupuesto } from "../nav-presupuesto/nav-presupuesto";
import { NavStageHistory } from "../nav-stage-history/nav-stage-history";
import { NavContactFunctions } from "../nav-contact-functions/nav-contact-functions";
import { NavFiles } from "../nav-files/nav-files";
import { Activities } from '../../activities/activities';

interface NavItem {
  item: number;
  name: string;
  active: boolean;
}

@Component({
  selector: 'app-nav-opportunities',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NavPresupuesto,
    NavStageHistory,
    NavContactFunctions,
    NavFiles,
    Activities
],  
  templateUrl: './nav-opportunities.html',
  styleUrl: './nav-opportunities.css'
})
export class NavOpportunities {
  public accService = inject(AccountService);
  
  public navItems: NavItem[] = [
    { item: 0, name: "Actividad", active: true },
    { item: 1, name: "Historial", active: false },
    { item: 2, name: "Presupuestos", active: false },
    { item: 3, name: "Historial de la etapa", active: false },
    { item: 4, name: "Funciones de contactos", active: false },
    { item: 5, name: "Notas", active: false },
    { item: 6, name: "Archivos", active: false }
  ];

  triggerAction(action: number): void {
    this.navItems = this.navItems.map((item, index) => ({
      ...item,
      active: index === action
    }));

    this.handleAdditionalActions(action);
  }

  private handleAdditionalActions(action: number): void {
    switch(action) {
      case 2:
        break;
      case 3:
        break;
    }
  }
}